'use client';

import { useEffect, useRef } from 'react';

import { getCookie } from '@shared/utils/cookies';
import {
  clearLoginEventCookie,
  LOGIN_EVENT_COOKIE_NAME,
} from '@shared/utils/loginEventCookie';
import { showToastWithRetry } from '@shared/utils/toastWithRetry';

import { pushLogin } from '../utils/authGtm';

const LOGIN_SUCCESS_MESSAGE = '로그인 되었어요';

/**
 * 로그인 완료 마커 쿠키를 소비해 `click_login` 발사 + 완료 토스트 노출.
 *
 * 로그인은 BFF 라우트에서 끝나고 307 로 리다이렉트돼 클라이언트에 성공 시점이 없다.
 * 라우트가 심은 마커를 여기서 읽고 **즉시 삭제**해 새로고침 중복 노출/집계를 막는다.
 *
 * 마커는 1회성이라 소비 주체가 하나여야 한다 — GA 와 토스트를 별도 컴포넌트로 나누면
 * 먼저 읽은 쪽이 쿠키를 지워 다른 쪽이 실행되지 않는다.
 */
export function LoginCompletionTracker() {
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) return;
    if (!getCookie(LOGIN_EVENT_COOKIE_NAME)) return;

    consumed.current = true;
    clearLoginEventCookie();
    void pushLogin({ btnName: '로그인' });

    // 타이머 정리를 cleanup 으로 돌려주지 않는다 — StrictMode 는 이펙트를
    // mount → cleanup → mount 로 돌리는데, 여기서 타이머를 걷어내면 두 번째 mount 가
    // `consumed` 가드에 걸려 아무것도 하지 않아 토스트가 영영 뜨지 않는다.
    // 타이머는 성공/타임아웃 시 스스로 멈춘다.
    showToastWithRetry(LOGIN_SUCCESS_MESSAGE);
  }, []);

  return null;
}
